// extracted by mini-css-extract-plugin
export default {"multiselectWrapper":"multiSelect_multiselectWrapper__lDfQw","caretIconWrapper":"multiSelect_caretIconWrapper__bnVzF"};